/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-26 17:09:15
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-10-09 17:09:14
 * @FilePath: \crm-product\src\views\performanceCalculation\views\result_statement\annual_network_performance_report\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import TablePage from '@/found/components/table_page';
import Form from '../detail/detail.vue';

export default {
  extends: TablePage,
  components: {
    Form,
  },
  name: 'WarningReportTable',
  data() {
    return {

    };
  },
  created() {
    this.getConfigList('main-list');
  },

  methods: {
    modalClick({
      val,
      row,
    }) {
      if (val.code === 'check_detail') {
        this.formConfig = {
          reportId: row.id,
        };
        this.modalConfig.title = '明细';
        this.openFull();
      }
    },
  },
};
